import * as React from 'react';
import { Badge } from '../../badge/badge';
import { TextVariantType } from '../../../../theme/type/text-type';
import { Tooltip } from '../../tooltip/tooltip';
import { cn, textVariantClass } from '../../../../utils/tailwind';

type CardTitleType = {
    actions?: React.ReactNode;
    title?: string | React.ReactNode;
    tooltip?: React.ReactNode;
    badge?: string | null;
    color?: TextVariantType | 'inherit';
    compact?: boolean;
};

export const CardTitle: React.FC<CardTitleType> = ({
    actions,
    title,
    tooltip,
    badge,
    color = 'secondary',
    compact = false,
}) => {
    return (
        <div
            className={cn(
                'relative z-[99] flex w-full items-center justify-between',
                compact ? 'mb-vsmall min-h-[2.8rem]' : 'mb-small min-h-[3.6rem]',
            )}
        >
            <div className="flex items-center gap-[1rem]">
                {title && tooltip ? (
                    <div
                        className={cn(
                            compact
                                ? 'text-[1.1rem] leading-[1.3rem] font-bold uppercase opacity-60'
                                : 'text-vsmall leading-medium font-bold uppercase opacity-60',
                            color === 'inherit' ? 'text-inherit' : textVariantClass[color],
                        )}
                    >
                        <Tooltip icon content={tooltip} position="bottom-right">
                            {title}
                        </Tooltip>
                    </div>
                ) : null}
                {title && !tooltip ? (
                    <div
                        className={cn(
                            compact
                                ? 'text-[1.1rem] leading-[1.3rem] font-bold uppercase opacity-60'
                                : 'text-vsmall leading-medium font-bold uppercase opacity-60',
                            color === 'inherit' ? 'text-inherit' : textVariantClass[color],
                        )}
                    >
                        {title}
                    </div>
                ) : null}
                {badge && (
                    <Badge variant="purple" size="small">
                        {badge}
                    </Badge>
                )}
            </div>
            {actions && <div className="flex items-center gap-vsmall">{actions}</div>}
        </div>
    );
};
